
import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserCircle } from '@phosphor-icons/react';

import { Spacer } from 'theSource/components';
import { FamilyMember } from '../../utils';
import { FamilyMemberListItem } from './components';
import {
  FamilyCoveredCardStyled,
  FamilyCoveredSectionStyled,
  FamilyCoveredFirstStyled,
  FamilyCoveredCircleStyled,
} from './FamilyCoveredStyled';

export interface FamilyCoveredProps {
  familyMembers?: FamilyMember[];
}

export const FamilyCovered = ({ familyMembers = [] }: FamilyCoveredProps) => {
  const { t } = useTranslation('pages.benefits');
  const theme = useTheme();

  return (
    <FamilyCoveredSectionStyled data-testid="family-covered">
      <h2 className="headline-3">
        {t('familyCovered', { length: familyMembers.length + 1 })}
      </h2>
      <Spacer height={4} />
      <FamilyCoveredCardStyled>
        <FamilyCoveredFirstStyled hasFamilyMembers={familyMembers.length > 0}>
          <FamilyCoveredCircleStyled>
            <UserCircle
              size={36}
              color={theme.palette.primary.main}
              alt="You are covered."
            />
          </FamilyCoveredCircleStyled>
          <Typography variant="body2">You</Typography>
        </FamilyCoveredFirstStyled>

        {familyMembers.map((person) => (
          <FamilyMemberListItem key={person.id} name={person.name} />
        ))}
      </FamilyCoveredCardStyled>
    </FamilyCoveredSectionStyled>
  );
};
